import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.gsdcuser.notice.item');
import { OnInit, Input, DoCheck } from '@angular/core';
import { Router } from '@angular/router';
import { Service } from "src/libs/portal/season/service";
import showdown from 'showdown';

@Component({
    selector: 'wiz-portal-gsdcuser-notice-item',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.gsdcuser.notice.item/view.scss */
/* src/app/portal.gsdcuser.notice.item/view.scss: no such file or directory */`],
})
export class PortalGsdcuserNoticeItemComponent implements OnInit, DoCheck {
    constructor(@Inject( Service)         public service: Service,@Inject( Router    )         private router: Router    ) { }

    @Input() notice_id: any;

    public info: any;
    public comments: any = [];
    // public newComment: any = "";

    public prev: any;
    public next: any;

    private lastUrl: string = "";

    public async ngDoCheck() {
        if (this.router.url !== this.lastUrl) {
            this.lastUrl = this.router.url;
            this.notice_id = WizRoute.segment.item;
            await this.load();
        }
    }

    public async ngOnInit() {
        await this.service.init();
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load", { notice_id: this.notice_id });
        if (code != 200) return window.location = "/dashboard";
        this.info = data.info;
        this.info.extra = JSON.parse(this.info.extra.replace(/'/g, '"'));
        this.comments = data.comments;
        // this.prev = data.prev;
        // this.next = data.next;
        await this.service.render();
    }

    public showdown(text) {
        const markdown = typeof text === 'string' ? text : '';
        let converter = new showdown.Converter();
        return converter.makeHtml(markdown);
    }

    public async commentWrite(comment: any) {
        if (!comment) return await this.service.alert.warning("댓글을 작성해주세요.");
        this.newComment = comment;
        const { code, data } = await wiz.call("commentWrite", { notice_id: this.notice_id, comment: this.newComment });
        if (code != 200) return await this.service.alert.error("Error!");
        this.newComment = "";
        await this.load();
        // await this.service.render();
    }

    public async removeComment(comment) {
        let res = await this.service.alert.error("댓글을 삭제하시겠습니까?", "닫기", "삭제");
        if (!res) return;
        const { code } = await wiz.call("remove_comment", comment);
        if (code != 200) return await this.service.alert.error("Error!");
        await this.load();
    }
}

export default PortalGsdcuserNoticeItemComponent;